module.exports = __webpack_public_path__ + "img/空白（页宽+静态文字）.22f9c95a.jpg";